export default __webpack_public_path__ + "static/media/boden.d2441073.png";